import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { Toast as TopoloToast, ToastViewport, toast as sharedToast, useToasts, } from '@topolo-io/ui-kit';
function mapVariant(variant) {
    if (variant === 'error')
        return 'destructive';
    return variant ?? 'default';
}
function fireToast(options) {
    const message = options.title ?? options.description ?? '';
    const toastOptions = {
        description: options.title ? options.description : undefined,
        durationMs: options.duration,
    };
    switch (options.variant) {
        case 'success':
            return sharedToast.success(message, toastOptions);
        case 'warning':
            return sharedToast.warning(message, toastOptions);
        case 'error':
            return sharedToast.error(message, toastOptions);
        case 'info':
            return sharedToast.info(message, toastOptions);
        default:
            return sharedToast.message(message, toastOptions);
    }
}
export function ToastComponent({ title, description, variant = 'default', onOpenChange }) {
    return (_jsx(TopoloToast, { title: title ?? '', description: description, variant: mapVariant(variant), onClose: () => onOpenChange?.(false) }));
}
export function ToastProvider({ children }) {
    return (_jsxs(_Fragment, { children: [children, _jsx(ToastViewport, {})] }));
}
export function useToast() {
    const currentToasts = useToasts();
    return {
        toast: fireToast,
        dismiss: sharedToast.dismiss,
        dismissAll: sharedToast.clear,
        toasts: currentToasts.map((item) => ({
            id: item.id,
            title: item.title,
            description: item.description,
            variant: item.variant === 'destructive' ? 'error' : item.variant,
        })),
    };
}
export function useToastActions() {
    const { toast, dismiss } = useToast();
    return React.useMemo(() => ({
        success: (title, description, options) => toast({ variant: 'success', title, ...(description && { description }), ...options }),
        error: (title, description, options) => toast({ variant: 'error', title, ...(description && { description }), ...options }),
        warning: (title, description, options) => toast({ variant: 'warning', title, ...(description && { description }), ...options }),
        info: (title, description, options) => toast({ variant: 'info', title, ...(description && { description }), ...options }),
        promise: (promise, messages, options) => {
            const loadingId = toast({
                variant: 'info',
                title: messages.loading,
                duration: 0,
                ...options,
            });
            promise
                .then((data) => {
                toast({
                    variant: 'success',
                    title: typeof messages.success === 'function' ? messages.success(data) : messages.success,
                    ...options,
                });
            })
                .catch((error) => {
                toast({
                    variant: 'error',
                    title: typeof messages.error === 'function' ? messages.error(error) : messages.error,
                    ...options,
                });
            })
                .finally(() => {
                setTimeout(() => {
                    dismiss(loadingId);
                }, 100);
            });
            return promise;
        },
    }), [toast, dismiss]);
}
